import $$ from 'cmn-utils'

const baseUrl = "/api/sys/system-notice/";
export default {
    get: (params) => {
        return $$.get(baseUrl + 'get', params)
    }

}